import { Button, Modal } from "@shopify/polaris";
import React, { useCallback, useReducer } from "react";
import { useMutation } from "@apollo/react-hooks";

import { handleError, reducerFn } from "../../helper";
import { CREATE_OR_UPDATE_INVOICE_FOR_SELLER } from "../../graphql/mutations";
import { useToastContext } from "../shared/ToastContext";

export default function CreateInvoiceForSeller({ node }) {
    const [state, setState] = useReducer(reducerFn, {
        open: false,
    });

    const { setNotify, toggleToast } = useToastContext();

    const handleOpenChange = useCallback(
        (open) => () => {
            setState({ open });
        },
        [],
    );

    const [createOrUpdateInvoiceForSeller, { loading }] = useMutation(
        CREATE_OR_UPDATE_INVOICE_FOR_SELLER,
        {
            onCompleted: () => {
                setNotify({ msg: "Create Invoice success", err: false });
                handleOpenChange(false)();
            },
            onError: (err) => {
                setNotify({ msg: handleError(err?.toString()), err: true });
            },
        },
    );

    const handleSubmit = useCallback(() => {
        if (!node || !node.id) return;

        toggleToast && toggleToast(true);
        setNotify && setNotify({ msg: null, err: false });
        createOrUpdateInvoiceForSeller({
            variables: {
                input: { userIDs: node.id },
            },
        });
    }, [createOrUpdateInvoiceForSeller, setNotify, toggleToast, node?.id]);

    return (
        <>
            <Button
                children="Create Invoice"
                onClick={handleOpenChange(true)}
                plain
            />

            <Modal
                open={state.open}
                onClose={handleOpenChange(false)}
                sectioned
                title="Create Invoice"
                primaryAction={{
                    content: "Submit",
                    onAction: handleSubmit,
                    loading,
                }}
                secondaryActions={[
                    { content: "Cancel", onAction: handleOpenChange(false) },
                ]}
            >
                <p>Are you sure to create to Invoice for last month?</p>
            </Modal>
        </>
    );
}
